import ShareItem from './share-item/share-item.vue';

export default {
  name: 'share-list',
  components: {
    ShareItem,
  },
  props: {
    shares: {
      type: Array,
      required: true,
    },
  },
};
